<template>
    <div class="d-inline-block" :class="{'pointer-events-none': user === null}">
        <div class="d-flex flex-row">
            <a :href="userLink"
               target="_blank"
               class="text-dark text-hover-primary h-100"
               @mouseover="show"
               @mouseleave="hide"
            >
                <div class="d-flex flex-row gap-2">
                    <UserAvatar v-if="showAvatar" :user="user" class="d-none d-lg-block"/>
                    <div class="d-flex flex-column justify-content-center">
                        <div>
                            {{ user ? user.name : __('general.unknown') }}
                        </div>
                        <div v-if="user && showEmail" class="font-size-xs text-muted text-lowercase mt-n1">
                            {{ user.email }}
                        </div>
                    </div>
                </div>
            </a>
            <Transition name="slide-fade">
                <div v-if="Permission.VIEW_ALL_USERS" v-show="showExtraInfo">
                    <div
                        class="position-absolute ml-4 bg-dark shadow rounded p-3 text-white font-size-sm pointer-events-none text-nowrap"
                        style="z-index: 999;"
                    >
                        <table v-if="extraInfo !== null" class="table table-sm table-borderless m-0 text-white">
                            <tr class="font-weight-bolder">
                                <td v-if="!extraInfo.has_payments_configured" colspan="2"
                                    class="text-warning text-center">
                                    <i class="fas fa-exclamation-triangle"/>
                                    {{ __('subscriptions.payments_are.not_configured') }}
                                </td>
                                <td v-else colspan="2" class="text-success text-center">
                                    <i class="fas fa-check"/>
                                    {{ __('subscriptions.payments_are.configured') }}
                                </td>
                            </tr>
                            <tr :class="{'text-warning': extraInfo.subscriptions_count === undefined || extraInfo.subscriptions_count === 0}">
                                <td class="font-weight-bold">{{ __('general.subscriptions') }}</td>
                                <td class="text-right">{{ extraInfo.subscriptions_count || 0 }}</td>
                            </tr>
                            <tr :class="{'text-warning': extraInfo.stores_count === undefined || extraInfo.stores_count === 0}">
                                <td class="font-weight-bold">{{ __('general.stores') }}</td>
                                <td class="text-right">{{ extraInfo.stores_count || 0 }}</td>
                            </tr>
                            <tr :class="{'text-warning': extraInfo.stocks_count === 0}">
                                <td class="font-weight-bold">{{ __('general.stocks') }}</td>
                                <td class="text-right">{{ extraInfo.stocks_count }}</td>
                            </tr>
                            <tr v-if="extraInfo.agency.id !== null && extraInfo.agency.id !== 1">
                                <td class="font-weight-bold">{{ __('general.agency') }}</td>
                                <td class="text-right">{{ extraInfo.agency.name }}</td>
                            </tr>
                        </table>
                        <Spinner v-else
                                 class="d-inline-block"
                                 :size="18"
                                 :speed="0.4"
                                 line-fg-color="#fff"
                                 line-bg-color="transparent"/>
                    </div>
                </div>
            </Transition>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';
import UserInitials from "./UserInitials.vue";
import UserAvatar from "./UserAvatar.vue";
import Spinner from "vue-simple-spinner";
import {PermissionsMixin} from "@js/permissions";

export default {
    components: {
        UserAvatar,
        UserInitials,
        Link,
        Spinner
    },

    mixins: [PermissionsMixin],

    props: {
        user: {
            type: Object,
            default: null
        },
        showEmail: Boolean,
        showAvatar: Boolean,
        preLoad: Boolean
    },

    data() {
        return {
            showExtraInfo: false,
            extraInfo: null
        }
    },

    mounted() {
        if (this.preLoad) {
            this.loadData();
        }
    },

    methods: {
        show() {
            if (!this.Permission.VIEW_ALL_USERS || this.user === null) {
                return;
            }

            this.loadData();
            this.showExtraInfo = true;
        },

        hide() {
            this.showExtraInfo = false;
        },

        loadData() {
            if (this.extraInfo === null && this.user != null) {
                axios.get(this.$route('ajax.users.extra', this.user.firebase_uid))
                    .then(response => {
                        this.extraInfo = response.data;
                    })
            }
        }
    },

    computed: {
        userLink() {
            if (this.user) {
                return this.$route('user.edit', this.user.id)
            }

            return '#'
        }
    }
}
</script>

<style scoped>
.slide-fade-enter-active {
    transition: all 0.15s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.18s ease-out;
}

.slide-fade-enter {
    transform: translateX(-6px);
    opacity: 0;
}

.slide-fade-leave-to {
    transform: translateX(8px);
    opacity: 0;
}
</style>
